import React from 'react';
import { CONF_LABELS } from '../../../../constants/Labels';
class LabelsSettings extends React.Component {
  constructor(props) {
    super(props);
    this.section = 'labels';
    // eslint-disable-next-line react/no-unused-class-component-methods
    this.invalidFileds = [];
  }

  render() {
    return (
      <div className="pluginSettingsSection" id={this.section}>
        <div
          className="placementDescription"
          onClick={e => this.props.toggleElement(e, '.settingsInputs')}
        >
          <div className="pluginSectionsTitle labelTitle">Labels Settings</div>
        </div>
        <div className="settingsInputs">
          <div
            className="settingsDescription description"
            dangerouslySetInnerHTML={{ __html: CONF_LABELS }}
          ></div>
          <div className="inputsRow">
            <div className="bigInput">
              <label>Label for skip</label>
              <input
                type="text"
                key={this.props.labels.lbl_countdown_skip.EN}
                name="lbl_countdown_skip"
                className="textFiled"
                defaultValue={this.props.labels.lbl_countdown_skip.EN}
                onBlur={e => this.props.validate(e, 'string', false, this)}
              />
              <div className="validationError"></div>
            </div>
          </div>
          <div className="inputsRow">
            <div className="bigInput">
              <label>Label for preroll countdow</label>
              <input
                type="text"
                key={this.props.labels.lbl_countdown_break_preroll.EN}
                name="lbl_countdown_break_preroll"
                className="textFiled"
                defaultValue={this.props.labels.lbl_countdown_break_preroll.EN}
                onBlur={e => this.props.validate(e, 'string', false, this)}
              />
              <div className="validationError"></div>
            </div>
          </div>
          <div className="inputsRow">
            <div className="bigInput">
              <label>Label for midroll countdow</label>
              <input
                type="text"
                key={this.props.labels.lbl_countdown_break_midroll.EN}
                name="lbl_countdown_break_midroll"
                className="textFiled"
                defaultValue={this.props.labels.lbl_countdown_break_midroll.EN}
                onBlur={e => this.props.validate(e, 'string', false, this)}
              />
              <div className="validationError"></div>
            </div>
          </div>
          <div className="inputsRow">
            <div className="bigInput">
              <label>Label for postroll countdown</label>
              <input
                type="text"
                key={this.props.labels.lbl_countdown_break_postroll.EN}
                name="lbl_countdown_break_postroll"
                className="textFiled"
                defaultValue={this.props.labels.lbl_countdown_break_postroll.EN}
                onBlur={e => this.props.validate(e, 'string', false, this)}
              />
              <div className="validationError"></div>
            </div>
          </div>
          <div className="more">
            <div className="inputsRow">
              <div className="bigInput">
                <label>Label for skip vpaid</label>
                <input
                  type="text"
                  key={this.props.labels.lbl_skip_vpaid.EN}
                  name="lbl_skip_vpaid"
                  className="textFiled"
                  defaultValue={this.props.labels.lbl_skip_vpaid.EN}
                  onBlur={e => this.props.validate(e, 'string', false, this)}
                />
                <div className="validationError"></div>
              </div>
            </div>
            <div className="inputsRow">
              <div className="bigInput">
                <label>Label more</label>
                <input
                  type="text"
                  key={this.props.labels.lbl_more.EN}
                  name="lbl_more"
                  className="textFiled"
                  defaultValue={this.props.labels.lbl_more.EN}
                  onBlur={e => this.props.validate(e, 'string', false, this)}
                />
                <div className="validationError"></div>
              </div>
            </div>
          </div>
          <div className="moreButtonWrapper">
            <a className="moreButton" onClick={e => this.props.toggleElement(e, '.more')}>
              Show more options <span>▼</span>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default LabelsSettings;
